module.exports = __webpack_public_path__ + "static/media/silnik1.160968bf.jpg";